import React from 'react'
import './Product_review.css';
import Verify from '../../../Assets/Verify.svg'


// Aproxima el promedio a la cantidad de estrellas (⭐)
const renderStars = (rating) => {
  const fullStars = Math.round(rating);
  return '⭐'.repeat(fullStars);
}

export default function Product_review({ProductData}) {
  // console.log("ProductData ::::::::::", ProductData)
  const reviews = ProductData.comodin_reviews || []

  if (reviews.length === 0) {
    return (
      <div></div>
    )
  }

  // Calcula el promedio de las calificaciones
  const averageRating = (reviews?.reduce((acc, curr) => acc + curr.rating, 0) / reviews?.length) || 5;

  return (
    <div className='col-12 justify-content-center'>
      <h1 style={{marginTop:"100px"}}>Evaluaciones de Clientes</h1>
      <div style={{fontSize:"20px", marginBottom:"50px"}}><strong style={{fontSize:"30px"}}>{averageRating.toFixed(1)}</strong>{renderStars(averageRating)} (+{reviews.length} comentarios)</div>
      <div className='gridCardContainer'>
        {reviews?.map(review => (
          <Product_review_card key={review.username} review={review} />
        ))}
      </div>
      {/* <div style={{border:"2px solid black", borderRadius:"15px", padding:"5px 10px", textAlign:"center", marginTop:"20px", cursor:"pointer"}}>Ver más</div> */}
    </div>
  )
}

function Product_review_card({review}) {
  return (
    <div className='Product_review_card'>
      {
        review.imageUrl.file_src && (
          <img loading="lazy" src={review.imageUrl.file_src}/>
        )
      }
      <strong>{review.username}</strong>
      <div style={{fontSize:"20px"}}>{renderStars(review.rating)} <span>{review.rating}</span></div>
      <p>{review.comment}</p>
      <div className='f'>
        <div>{review.date}</div>
        <div><img loading="lazy" style={{width:"20px"}} src={Verify}/> <strong>Verificado</strong></div>
      </div>
    </div>
  )
}

// import React from 'react'
// import './Product_review.css';

// export default function Product_review() {

//   const reviews = [
//     {
//       // TODO:
//     }
//   ]

//   return (
//     <div className='col-12 justify-content-center'>
//       <h1 style={{marginTop:"100px",}}>Evaluaciones de Clientes</h1>
//       <div style={{fontSize:"20px", marginBottom:"50px"}}><strong style={{fontSize:"30px"}}>4.7</strong>⭐⭐⭐⭐⭐ (+100 comentarios)</div>
//       <div className='gridCardContainer'>
//         {
//           reviews.map(review=>
//             < Product_review_card review={review} />
//           )
//         }
//       </div>
//       <div style={{border:"2px solid black", borderRadius:"15px", padding:"5px 10px", textAlign:"center", marginTop:"20px", cursor:"pointer"}}>Ver más</div>
//     </div>
//   )
// }

// function Product_review_card({review}) {
//   return (
//     <div className='Product_review_card'>
//       <img src="https://firebasestorage.googleapis.com/v0/b/demoda-inside.appspot.com/o/comodin%2FrrnFyUloDuGyZEwQxbvC%2FrrnFyUloDuGyZEwQxbvCsection6.jpeg?alt=media&token=6e79714d-14c6-47af-b8f2-2bcd16dfb69e" alt="" />
//       <div>@yoyis</div>
//       <div style={{fontSize:"20px"}}>⭐⭐⭐⭐⭐ <span>4.9</span></div>
//       <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit saepe minima delectus ullam corporis pariatur odio nisi assumenda vero culpa modi aut minus perspiciatis, enim, vel, repellat temporibus labore molestiae!</p>
//       <div className='date'>14-08-2024</div>
//     </div>
//   )
// }

